import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { Link } from 'react-router-dom';
import constants from '../../constants';
import { useUserStore } from '../../stores/userStore';

const Home = () => {
	const { user } = useUserStore();
	const incompleteQuery = useQuery({
		queryKey: ['incompleteRequests', user?.id],
		queryFn: async () => {
			const { data } = await axios.get(
				`/clients/${user?.id}/incomplete-requests`,
			);
			return data;
		},
	});
	const openQuery = useQuery({
		queryKey: ['openRequests', user?.id],
		queryFn: async () => {
			const { data } = await axios.get(`/clients/${user?.id}/open-requests`);
			return data;
		},
	});
	const closedQuery = useQuery({
		queryKey: ['closedRequests', user?.id],
		queryFn: async () => {
			const { data } = await axios.get(`/clients/${user?.id}/closed-requests`);
			return data;
		},
	});
	return (
		<div className="home page-wide">
			<div className="flex flex-row items-center justify-between mb-4">
				<h1 className="mb-0">Home</h1>
				<Link to="/" className="btn btn-primary">
					New Service Request
				</Link>
			</div>
			{incompleteQuery?.data?.length > 0 && (
				<>
					<h2>Incomplete Service Requests (more info needed)</h2>
					<table className="table w-full mb-4">
						<thead>
							<tr>
								<th>Date</th>
								<th>Service</th>
								<th>Agency</th>
								<th>Missing Questionnaires</th>
							</tr>
						</thead>
						<tbody>
							{incompleteQuery?.data?.map((request) => (
								<tr key={request.id}>
									<td>{new Date(request.request_dttm).toLocaleDateString()}</td>
									<td>{request.taxonomy_detail}</td>
									<td>{request.external_211_service.data.locations[0].name}</td>
									<td>
										{request.missingAssessments.map(
											({ name, care_quest_group_id }) => (
												<Link
													className="inline-block px-2 link link-primary"
													key={`${name}-${care_quest_group_id}`}
													to={`/assessments/${care_quest_group_id}`}
												>
													{name}
												</Link>
											),
										)}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</>
			)}
			<h2>In-progress Service Requests</h2>
			<table className="table w-full mb-4">
				<thead>
					<tr>
						<th>Date</th>
						<th>Service</th>
						<th>Agency</th>
						<th>Status</th>
					</tr>
				</thead>
				<tbody>
					{openQuery?.isLoading && (
						<tr>
							<td colSpan={4}>Loading...</td>
						</tr>
					)}
					{openQuery?.isError && (
						<tr>
							<td colSpan={4}>Error loading open service requests</td>
						</tr>
					)}
					{!openQuery?.isLoading &&
						!openQuery?.isError &&
						openQuery?.data?.length === 0 && (
							<tr>
								<td colSpan={4}>No open service requests</td>
							</tr>
						)}
					{!openQuery?.isLoading &&
						!openQuery?.isError &&
						openQuery?.data?.map((request) => (
							<tr key={request.id}>
								<td>{new Date(request.request_dttm).toLocaleDateString()}</td>
								<td>{request.taxonomy_detail}</td>
								<td>{request.external_211_service.data.locations[0].name}</td>
								<td>{constants.status[request.request_status]}</td>
							</tr>
						))}
				</tbody>
			</table>
			<p>Completed Service Requests: {closedQuery?.data?.length}</p>
		</div>
	);
};

export default Home;
